import { Icon, PathButton } from "shared/react";
import { getImageStyle } from "shared/util/style";

export function GroupsNavigation({ children }: { children: React.ReactNode }): React.ReactElement {
	return (
		<header className="panel pad-none" style={getImageStyle("/img/chat.angled.svg", 180)}>
			<div className="pad-2x width-wide">{children}</div>
			<nav className="flex-row pin-top pin-right">
				<a className="button button-quiet" href="/search/groups" title="Search groups">
					<Icon icon="search" />
				</a>
				<a className="button button-quiet" href="/groups/new" title="Create group">
					<Icon icon="add" />
				</a>
			</nav>
			<nav className="flex-row flex-stretch size-small space-none width-wide">
				<PathButton path="/groups">Groups</PathButton>
				<PathButton path="/invites">Invites</PathButton>
			</nav>
		</header>
	);
}
